import { createFileRoute } from '@tanstack/react-router'
import {operators} from '@/constants/operators'
import UserFilter from '@/components/user-filter'
import {Card, CardContent, CardTitle, CardHeader} from '@/components/ui/card'
import {
  type ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart'
import {useState} from 'react'

import {Bar, BarChart, CartesianGrid, XAxis} from 'recharts'

export const Route = createFileRoute('/client/sale/report/charts/')({
  component: ClientSaleReportChart,
})


const chartConfig: ChartConfig = {
  count: {
    label: 'تعداد',
    color: '#2563eb',
  },
  sum: {
    label: 'مجموع',
    color: '#60a5fa',
  },
}

function ClientSaleReportChart () {
  const [filtered, setFiltered] = useState<any>()
  const [meta, setMeta] = useState<any>()
  const isOperator = filtered?.findIndex((o: any) => o.operator_id) > -1
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>نمودار ها</CardTitle>
        </CardHeader>
        <CardContent>
          <UserFilter
            table='walletTransaction'
            filtered={filtered}
            setFiltered={(data) =>
              setFiltered(
                data?.filter((d: any) => {
                  if (Object.values(d).filter(f => f == null).length > 0) {
                    return false
                  }
                  return true
                }).map((d: any) => ({
                  ...d,
                  count: d.count000value,
                  sum: Number(d.sum000value),
                }))
              )
            }
            setMeta={setMeta}
            groupBy={['operator_id', 'product_name']}
          />

          {filtered && (
            <ChartContainer config={chartConfig} className='max-h-[500px] w-full'>
              <BarChart accessibilityLayer data={filtered}>
                <CartesianGrid vertical={false} />
                <ChartTooltip content={<ChartTooltipContent />} />
                <ChartLegend content={<ChartLegendContent />} />

                <XAxis
                  dataKey={isOperator ? 'operator_id' : 'product_name'}
                  tickLine={false}
                  tickMargin={10}
                  axisLine={false}
                  tickFormatter={(value) =>
                    isOperator ? operators.find((o) => o.id == value)?.title ?? '-' : value
                  }
                />
                <Bar dataKey='count' fill='var(--color-count)' radius={4} />
                <Bar dataKey='sum' fill='var(--color-sum)' radius={4} />
              </BarChart>
            </ChartContainer>
          )}
        </CardContent>
      </Card>
    </>
  )
}
